export const getTvaRate = (tva: string) => {
  return typeof tva === 'string' && tva?.includes('%')
    ? parseFloat(tva?.replace('%', '')) / 100
    : 0
}
